import React from "react";
import styles from "./Awards.module.css";

import { FaCalendar } from "react-icons/fa";
import { FaMapPin } from "react-icons/fa";

const AwardsEntries = [
    {
        firm: "Hermes Hackaton", 
        title: "1st place", 
        date: "10/2022", 
        location: "Cluj-Napoca, Romania",
        content: [
            {
                type: "text", 
                content: "As a result of winning the 1st place we secured an internship at fme Romania."
            }
        ],
    },
    {
        firm: "iTec Hackaton", 
        title: "1st place", 
        date: "05/2021", 
        location: "Timișoara, Romania",
        content: [
            {
                type: "text", 
                content: "Despite beeing the only highschool students out of 35 teams of university students me and my partner managed to stand out and win the first place. We even received an offer for an internship at Haufe but due to the challenges of relocating to Timișoara we had to decline the opportunity."
            }
        ],
    }
]

const Awards = ({  }) => {
    return (
        <div className={styles.container}>
            <div className={styles.timeline}>
                {AwardsEntries.map((entry) => (
                    <div key={`${entry.firm}-${entry.date}`} className={styles.entry}>
                        <div className={styles.entryHeader}>
                            <div className={styles.headerTexts}>
                                <div className={styles.headerTopRow}>
                                    <p className={styles.firm}>{entry.firm}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.date}>{entry.date}</p>
                                        <FaCalendar className = {styles.icon} />
                                    </div>
                                </div>
                                <div className={styles.headerBottomRow}>
                                    <p className={styles.title}>{entry.title}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.location}>{entry.location}</p>
                                        <FaMapPin className = {styles.icon} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.content}>
                            {entry.content.map((section, idx) => {
                                if (section.type === "text") {
                                    return (
                                        <p key={idx} className={styles.paragraph}>{section.content}</p>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Awards;